import { IConfig } from 'interfaces/config';
import { BehaviorSubject, Observable } from 'rxjs';
import * as rxjsOperators from 'rxjs-operators';

import { IProductNew } from '../interfaces/product';
import apiService, { ApiService } from './api';

export class ConfigService {
  private configProduct$ = new BehaviorSubject<IConfig>(null);
  private selectedProduct$ = new BehaviorSubject<IProductNew>(null);
  private drawerVisibility$ = new BehaviorSubject<
    null | 'upSell' | 'emailConfirmation' | 'acceptMoreThan12Installments' | 'backRedirect'
  >(null);

  constructor(private api: ApiService) {}

  public saveConfig(config: IConfig): Observable<any> {
    const productId = this.selectedProduct$.value.id;

    return this.api
      .put(`/config/${productId}`, { id: productId, ...config })
      .pipe(rxjsOperators.tap(config => this.configProduct$.next(config)));
  }

  public setSelectedProduct(product: IProductNew) {
    return this.loadConfigProduct(product.id).pipe(
      rxjsOperators.loader(),
      rxjsOperators.tap(() => {
        this.selectedProduct$.next(product);
      })
    );
  }

  public getSelectedProduct() {
    return this.selectedProduct$.asObservable();
  }

  public showDrawer(
    configName: 'upSell' | 'emailConfirmation' | 'acceptMoreThan12Installments' | 'backRedirect',
    product: IProductNew
  ) {
    this.setSelectedProduct(product)
      .pipe(rxjsOperators.tap(() => this.drawerVisibility$.next(configName)))
      .subscribe();
  }

  public hideDrawer() {
    this.drawerVisibility$.next(null);
  }

  public getVisibility() {
    return this.drawerVisibility$.asObservable();
  }

  public loadConfigProduct(id: number): Observable<IConfig> {
    const defaultValue: IConfig = {
      hasThankyouUpsell: false,
      requestEmailConfirmation: false,
      acceptMoreThan12Installments: false,
      isOnlyUpsell: { active: false, redirect: undefined },
      backRedirect: { active: false, id: undefined, url: undefined }
    };

    return this.api.get(`/config/${id}`).pipe(
      rxjsOperators.tap(config => this.configProduct$.next(config)),
      rxjsOperators.map(config => ({ ...defaultValue, ...config }))
    );
  }

  public getProductConfig() {
    return this.configProduct$.asObservable();
  }
}

export const ConfigServiceFactory = () => new ConfigService(apiService);

export const configService = ConfigServiceFactory();
